<div class="d-flex justify-content-center flex-column mt-3">
  <div class="text-center alert alert-danger mb-0 p-3" role="alert">
    <i class="fad fa-exclamation-triangle fa-2x animated rotateIn"></i><br>
    <div class="mt-3">{{ 'UNREMOVABLE_WARNING/TEXT' | translate }}</div>
  </div>
</div>